import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  profileHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  profileSection: {
    marginBottom: theme.spacing(2),
  },
  profileSectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: "1rem",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    margin: 0,
  },
  // LinkedIn profiles — Grid layout, desktop same line, label + value on new lines
  linkedInProfiles: {
    marginBottom: theme.spacing(2),
  },
  linkedInProfilesTitle: {
    display: "block",
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.08em",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  companyValueProps: {
    marginBottom: theme.spacing(2),
  },
  companyValuePropsTitle: {
    display: "block",
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.08em",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  companyValuePropsBox: {
    border: "1px solid #E5E7EB",
    backgroundColor: "#FAFBFC",
    borderRadius: 8,
    padding: theme.spacing(1.25),
    color: theme.palette.text.primary,
    whiteSpace: "pre-line",
    lineHeight: 1.5,
  },
  linkedInProfilePillLink: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.25),
    padding: theme.spacing(0.875, 1.25),
    borderRadius: 8,
    border: "1px solid #E5E7EB",
    backgroundColor: "#FAFBFC",
    color: "inherit",
    textDecoration: "none",
    transition: "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    height: "100%",
    "&:hover": {
      backgroundColor: "#F0F7FF",
      borderColor: "#0A66C2",
      boxShadow: "0 1px 3px rgba(10, 102, 194, 0.12)",
    },
    "&:focus-visible": {
      outline: "2px solid #0A66C2",
      outlineOffset: 2,
    },
  },
  linkedInProfilePillIcon: {
    flexShrink: 0,
    fontSize: 18,
    color: "#0A66C2",
    marginTop: 2,
  },
  linkedInProfilePillContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
  },
  linkedInProfileRole: {
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: theme.palette.text.secondary,
  },
  linkedInProfileName: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  linkedInProfilePillArrow: {
    flexShrink: 0,
    fontSize: 14,
    color: "#0A66C2",
    opacity: 0.85,
    marginTop: 2,
  },
  profileAvatar: {
    marginRight: theme.spacing(2),
    boxShadow: theme.shadows[4],
  },
  profileName: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  profileSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
  },
  infoCard: {
    height: "100%",
    minWidth: 0,
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[2],
  },
  cardContent: {
    padding: theme.spacing(1.5),
    minWidth: 0,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  cardIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "#070639",
    color: theme.palette.primary.contrastText,
    marginRight: theme.spacing(1.5),
  },
  cardLabel: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  cardValue: {
    minHeight: 20,
    minWidth: 0,
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    fontSize: "0.875rem",
    fontWeight: 400,
    color: theme.palette.text.secondary,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    lineHeight: 1.4,
  },
  emptyValue: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
  },
  targetInfoSidebar: {
    position: "sticky",
    top: 20,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
  },
  targetInfoTitle: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "1rem",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
  },
  targetInfoItem: {
    marginBottom: theme.spacing(1.5),
  },
  targetInfoLabel: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  targetInfoValue: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  chip: {
    fontSize: "0.75rem",
    height: 28,
    fontWeight: 500,
  },
  linkedinLink: {
    color: "#070639",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  linkedinIcon: {
    fontSize: 14,
    marginLeft: 4,
    color: "#070639",
  },
  actionButton: {
    height: 36,
    width: 84,
    padding: 2,
    marginRight: 15,
  },
  deleteButton: {
    height: 36,
    background: theme.palette.error.main,
    padding: 2,
    width: 96,
  },
}));
